<template lang="pug">
UiStack(vertical)
  UiStack
    UiStackItem(fill)
      .ui-card-section-title {{ $t("companies.tabs.approvers") }}
    UiStackItem
      UiButton(
        variant="primary"
        @click="exportApprovalLogs()"
        icon="FileDownload"
      ) {{ $t("companies.export_to_excel") }}
  RestTable(
    namespace="approvers_log"
    :headers="headers"
    ref="ApproversLogTable"
    :fetch-handler="getData"
    embed
  )
    template(#filters="{ filters, updateFilters }")
      UiStack
        UiStackItem
          UiFormGroup(
            :label="$t('companies.basic.vendor')"
            label-for="name-input"
            label-cols="4"
          )
            UiInput#name-input(
              :modelValue="filters.name"
              inputSize="30"
              :allowClear="true"
              @update:modelValue="updateFilters({ name: $event })"
            )
        UiStackItem
          UiFormGroup(
            :label="$t('companies.automation.bill_id')"
            label-for="invoice-number-input"
            label-cols="4"
          )
            UiInput#bill-id-input(
              :modelValue="filters.remote_key"
              inputSize="30"
              :allowClear="true"
              @update:modelValue="updateFilters({ remote_key: $event })"
            )
        UiStackItem
          UiFormGroup(
            :label="$t('companies.automation.remote_key')"
            label-for="bill-id-input"
            label-cols="4"
          )
            UiInput#bill-id-input(
              :modelValue="filters.bill_id"
              @update:modelValue="updateFilters({ bill_id: $event })"
              inputSize="30"
              :allowClear="true"
            )
</template>

<script>
import ApiApprovalLogs from "@/api/approval_logs.js";
import ApiCompanies from "@/api/companies";

export default {
  data() {
    return {
      headers: [
        {
          key: "id",
          label: "#",
          sortable: true,
          squeeze: true,
        },
        {
          key: "vendor",
          label: "Vendor",
          sortable: true,
          squeeze: true,
        },
        {
          key: "invoice_number",
          label: "Bill ID",
          sortable: true,
          squeeze: true,
        },
        {
          key: "bill_id",
          label: "Invoice Number",
          sortable: true,
          squeeze: true,
        },
        {
          key: "invoice_date",
          label: "Invoice Date",
          sortable: true,
          squeeze: true,
        },
        {
          key: "approver_set",
          label: "Approver Set",
          sortable: true,
          squeeze: true,
        },
        {
          key: "factual_verificator_set",
          label: "Factual Verificator Set",
          sortable: true,
          squeeze: true,
        },
        {
          key: "used_flow",
          label: "Used Active Flow",
          sortable: true,
          squeeze: true,
        },
        {
          key: "approve_status",
          label: "Circulation Status",
          sortable: true,
          squeeze: true,
        },
        {
          key: "created_at",
          label: "Timestamps",
          sortable: true,
          squeeze: true,
        },
      ],
    };
  },

  methods: {
    exportApprovalLogs() {
      ApiCompanies.exportApprovalLogs(this.$route.params.id)
        .then((resp) => {
          let fileURL = window.URL.createObjectURL(new Blob([resp.data]));
          let fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", `approval_logs.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
        })
        .catch((e) => {});
    },

    getData(params, config) {
      this.inProgress = true;
      return ApiApprovalLogs.FetchLogs(
        this.$route.params.id,
        params,
        config,
      ).then((resp) => {
        return {
          items: resp.data.approval_logs,
          meta: resp.data.meta,
        };
      });
    },
  },
};
</script>
